import styled from "styled-components";
import { theme } from "../../styles/theme";

export const WrapperStatus = styled.div`
  display: flex;
  align-items: center;
  padding: 6px 15px 5px 15px;
  border-radius: 16px;
  height: 32px;
  width: fit-content;
  background-color: ${({ background }) => background};
  color: ${({ color }) => color};
  font-size: ${theme.fonts.size.default};
  font-family: ${theme.fonts.family};
`;

export const WrapperFiltersTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 136px;
  border-radius: 15px;
  box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.03);
  padding: 12px 0 13px 0;
`;

export const WrapperFilterOption = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 40px;
  padding-left: 18px;
  cursor: pointer;

  &:hover {
    background-color: ${theme.colors.grey3};
  }
`;